<template><transition name="file-fade">
    <div class="file-manager">
        <div class="mask"></div>
        <div class="dig" :style="{height: con_height}" v-dlgdrag>
            <div class="dig_title clearFix">
                <div class="fl"><b class="mark_choose"></b>{{dig_title}}</div>
                <Icon class="fr" type="close-round" @click.native="dialogClose"/>
            </div>
			<div class="dig-main clearFix">
				<div class="main-left">
					<Tabs v-model="tabtype" @on-click="tabSwitch">
						<TabPane v-for="(pane, i) in tabpanes" :key="i" :name="pane.name"
						:label="pane.alias" :style="{height: con_main_left_height}">
							<div class="tanchuang-content">
								<template v-if="items.length">
									<div class="tanchuang-content-box">
										<div style="height:100%;" v-bar="{preventParentScroll: true,scrollThrottle: 30}">
											<div>
												<ul class="main-left-list clearFix">
													<li v-for="(item, i) in items" :key="item.id" class="list-li fl">
														<div class="list-li-top" :class="{selected: selectedIdx.findIndex((v)=>{return v==i})>-1}" style="height:63px;position:relative;background-color: #eee;"
														@click.stop="imgFocus(i, item.fpath)">
															<div class="loading"></div>
															<img v-adapt :src="item.ftype.toLowerCase()=='mp3'?
															soundGif:item.fpath" 
															:title="'类型：'+item.ftype+'\n大小：'+item.fsize+'\n尺寸：'+item.width+'*'+item.height+'像素\n修改日期：'+item.ftime" />
															<div class="selectState">
																<span class="iconfont icon-dui" style="font-size: 32px;"></span>
															</div>
														</div>
														<div @dblclick="renameid = i" class="list-li-bottom" title="双击此处重命名">
															<template v-if="renameid == i"><input v-model="item.fbasename" @keyup.enter="fileRename(i, $event)" class="inprename" />{{item.fname.replace(/^[^\.]+\./i, '.')}}</template>
															<template v-else>{{item.fname}}</template>
														</div>
														<Icon @click.native="fileDelete(item.fname)" class="list-li-delete" type="close-round" style="font-size:10px;"/>
													</li>
												</ul>
												<div class="clearFix"></div>
												<Page class="page-btn" @on-change="pageSwitch" :current="curr_page" 
												:page-size="page_size" :total="items_total"></Page>
												<div style="clear: both;height: 2px;width: 100%;overflow: hidden;"></div>
											</div>
										</div>
									</div>
									<div style="bottom:10px;" v-if="getFiles.length" class="confirm_btn" @click="picSelect">确定({{getFiles.length}})</div>
								</template>
								<template v-else><span class="empty">{{file_err_str}}</span></template>
								
							</div>
						</TabPane>
					</Tabs>
					<div class="searchAndOpera">
						<div v-if="!getFiles.length" class="page_search">
							<Input v-model="keyword" placeholder="按文件名查找" @keyup.native.enter="fileSearch">
								<Button @click="fileSearch" slot="append" icon="ios-search"></Button>
							</Input>
						</div>
						<div v-else class="page_opera">
						  <template v-if="multiselect">
							<div class="opera-list" @click="selectAll">全选</div>
							<div class="opera-list" @click="deleteBatch">批量删除</div>
						  </template>
							<Select class="opera-list-sele" @on-change="fileMoveTo" placeholder="移动至" style="width:100px">
							<!-- <Select class="opera-list-sele" @on-change="fileMoveTo" placeholder="移动至" style="width:100px" filterable> -->
								<Option :value="category" v-for="category in categoryTree" :key="category">{{parseTitle(category)}}</Option>
							</Select>
							<div class="opera-list" @click="unSelect">取消选择</div>
						</div>
					</div>
				</div>
				<div class="main-right fr" style="">
					<div style="height:100%;">
						<div class="page-setup">
							<div class="upFile">
								<Upload :accept="file_accept" :max-size="file_maxsize" :on-success="uploadSuccess"
								:on-exceeded-size="maxSizeTips" multiple :action="uploadUrl" :show-upload-list="false"
								:data="{sid,token,maxFileSize: file_maxsize * 1024,fileType: file_allowext,tag: cur_category}">
									<Button type="success">
										<i class="ivu-icon ivu-icon-ios-cloud-upload-outline" style="font-size: 18px;padding-right: 10px;"></i>
										上传文件</Button>
								</Upload>
							</div>
							<div class="categoryBox">
								<div style="height:100%;" v-bar="{preventParentScroll: true,scrollThrottle: 30}">
									<div>
										<div v-for="category in categories" :key="category" @click.stop="categorySearch(category)" class="category-main">
											
											<div class="father" :class="{active: cur_category == category}">
												<b class="mark_choose"></b>
												<div v-if="renameCtag == category"> 
													<input @click.stop="" class="catrename" placeholder="分类名称"></input>
													<Button style="width:50px;" class="catrename" @click.native.stop="categoryEdit(category, $event)">确定</Button>
												</div>
												<div v-else class="clearFix" style="padding-right:5px;">
													<template v-if="category">
													<Icon v-if="! subCategoryClose[category]" style="line-height:13px;" class="fl page-setup-father" type="plus-round" @click.native.stop="branchOpen('plus', category)"></Icon>
													<Icon v-else class="fl page-setup-father" style="line-height:13px;" type="minus-round" @click.native.stop="branchOpen('minus', category)"></Icon>
													</template>
													<span>{{parseTitle(category)}}</span>
													<div class="fr" v-if="category">
														<i class="page-setup-li iconfont icon-bianji" title="编辑分类" @click.stop="showCateInput(category, $event)"></i>
														<i class="page-setup-li iconfont icon-shezhi1" title="设置上级分类" @click.stop="categoryTofather(category)"></i>
														<i class="page-setup-li iconfont icon-chuyidong" title="删除分类" @click.stop="categoryDelete(category)"></i>
													</div>
												</div>
											</div>
											<div v-if="subCategoryClose[category]" :class="{active: cur_category == subcategory}"
											class="children" v-for="subcategory in category_children[category]" 
											:key="subcategory" @click.stop="categorySearch(subcategory)">
												<b class="mark_choose"></b>
												<div v-if="renameCtag == subcategory"> 
													<input @click.stop="" class="catrename" placeholder="分类名称" ></input>
													<Button style="width: 56px;" class="catrename" @click.native.stop="categoryEdit(subcategory, $event)">确定</Button>
												</div>
												<div v-else class="clearFix" style="padding-right:5px;">
													<span style="line-height:22px;">{{parseTitle(subcategory)}}</span>
													<div class="fr">
														<i class="page-setup-li iconfont icon-bianji" title="编辑分类" @click.stop="showCateInput(subcategory, $event)"></i>
														<i class="page-setup-li iconfont icon-shezhi1" title="设置上级分类" @click.stop="categoryTofather(subcategory, category)"></i>
														<i class="page-setup-li iconfont icon-chuyidong" title="删除分类" @click.stop="categoryDelete(subcategory)"></i>
													</div>
												</div>
											</div>
											<div class="children" v-if="subCategoryClose[category]" style="border-bottom: 1px solid #dddee1;">
												<b class="mark_choose"></b>
												<input class="children_ipt" @click.stop="" placeholder="分类名称"></input>
												<Button @click.native.stop="addSubCategory(category, $event)">确定</Button>
											</div>
										</div>
										<div v-if="category_err_str" style="color:#f00;text-align:center;">{{category_err_str}}</div>
									</div>
								</div>
							</div>
							<Input class="setup-btn" placeholder="按Enter键添加分类" 
							v-model="catename" @on-keyup.enter="addCategory"></Input>
						</div>
					</div>
				</div>
			</div>
        </div>
		
		<Modal :width="370" v-model="showSuperCate" title="设置上级分类" @on-ok="superCategorySet">
			<ul class="supercate-set">
				<li>
					<label class="ctitle">分类名称</label>
					<div class="content">{{parseTitle(current_cname)}}</div>
				</li>
				<li>
					<label class="ctitle">上级分类</label>
					<div class="content">
						<Select v-model="current_fathercname" style="width:200px">
							<Option v-for="(category, c) in categories"
							:value="category||'top'" :key="c">{{ parseTitle(category||'最上层') }}</Option>
						</Select>
					</div>
				</li>
			</ul>
		</Modal>
	</div>
</transition></template>

<script>
import jGlobal from '@/global';
import EventBus from '@/common/events';
import Dlgdrag from '@/common/dlgdrag';

let loadFilesByXhr = (options = {}, callback) => {
	if (! $.isPlainObject(options)
		|| ! $.isFunction(callback)) {
		console.error('Get files - failed1')
		return false
	}
	
	jGlobal.xhrPost('file/lists', $.extend({}, options), res => {
		if (! $.isPlainObject(res) || $.isEmptyObject(res)) {
			console.error('Get files - failed2');
			return false
		}
		callback.apply(null, [res])
	}, err => console.error(err))
}, loadCategoryByXhr = (options = {}, callback) => {
	if (! $.isPlainObject(options)
		|| ! $.isFunction(callback)) {
		console.error('Get categories - failed1');
		return false
	}

	jGlobal.xhrPost('file/category', $.extend({}, options), res => {
		if (! $.isPlainObject(res) || $.isEmptyObject(res)) {
			console.error('Get categories - failed2');
			return false
		}
		callback.apply(null, [res])
	}, err => console.error(err))
};

export default
{
	mixins: [Dlgdrag],
	data (){
		return {
			selectedIdx: [],
			getFiles: [],
			showSuperCate: false,
			current_cname: ' ',
			current_fathercname: '',
			catename: '',
			renameid: -1,
			renameCtag: '-1',
			tabpanes: [
				{"alias": "我的文件","name": "wxall"},
				{"alias": "图片","name": "pic"},
				{"alias": "音频","name": "mp3"}
			],
			dig_title: "我的文件",
			items_total: 0,
			items: [],
			cur_category: '',
			categories: [],
			subCategoryClose: {},
			category_children: {},
			curr_page: 1,
			page_size: 15,
			keyword: '',
			tabtype: 'wxall',
			filemtype:'',
			filestype: {},
			file_accept: '',
			file_maxsize: 1024,
			file_allowext: '',
			file_err_str:'加载中...',
			category_err_str: '',
			sid: '',
			token: '',
			uploadUrl: jGlobal.remoteUrl('file/upload'),
			soundGif: jGlobal.remoteStaticUrl('image/sound.gif')
		}
	},
	created (){
		let _ftype_ = '';
		this.filemtype = this.fmtype;
		if (this.filemtype == 'tabicon') {
			_ftype_ = this.filemtype;
			this.filemtype = 'pic'
		}
		// Set 'file-manager' type
		if ($.inArray(this.filemtype, ['pic','mp3']) < 0) this.filemtype = 'all';
		if (this.filemtype != 'all') {
			let _panes_ = [];
			this.tabtype = this.filemtype;
			this.tabpanes.forEach(c => (c.name == this.filemtype) && _panes_.push(c));
			this.tabpanes = _panes_
		}

		this.sid = this.$cookie.get('PHPSESSID');
		this.token = $.ajaxSettings.data.token;
		// Get 'files' list
		loadFilesByXhr({type: this.tabtype}, res => {
			if ('ERROR' == res.result || '') {
				this.file_err_str = res.data.errmsg;
				return false
			}
			
			this.items = res.data || [];
			this.items_total = parseInt(res.total || 0);
			this.curr_page = res.page || 1;
			this.page_size = res.pagesize || 15;
			if (! this.items || ! this.items.length) this.file_err_str = '尚未上传资源'
		});
		// Get 'files' type
		jGlobal.xhrPost('file/types', {}, res => {
			if (! $.isPlainObject(res) || $.isEmptyObject(res)) return false;
			
			this.filestype = res;
			let extobj = res[this.tabtype] || {};
			this.file_accept = extobj.fileext || '';
			this.file_allowext = extobj.allowext || '';
			// 单位KB
			if (_ftype_ == 'tabicon') this.file_maxsize = 40;
			else this.file_maxsize = (extobj.upload_size || 2) * 1024
		 }, err => console.error(err));
		// Get 'categories' list
		loadCategoryByXhr({}, res => {
			if (res.result == 'ERROR') {
				this.category_err_str = res.data.errmsg;
				return false
			}
			this.categories = res.catearr || [];
			this.category_children = res.childcatearr || {}
		})
	},
	mounted (){
		EventBus.$on("document_mousedown", e => {
			let $target = $(e.target || e.srcElement);
			// Destroy 'rename'
			if (! $target.is('.inprename')) this.renameid = -1;
			if (! $target.closest('.catrename').length) this.renameCtag = '-1'
		})
	},
	computed: {
		categoryTree (){
			let trees = [];
			this.categories.forEach(c => {
				trees.push(c);
				let subarr = this.category_children[c] || [];
				if (subarr.length > 0) trees.push(...subarr)
			});
			return trees
		}
	},
	directives: {
		adapt: {
			inserted (el, binding){
				$(el).css("visibility",'hidden');
				$(el).on("load", function(event){
					let img = event.target,
					w, h, t, W = 102, H = 60,
					cw = img.width, ch = img.height;
					if (cw == 0 || ch == 0) {cw = W;ch = H}
					if (cw > ch * W / H) {
						w = Math.min(W, cw);
						h = (ch * w) / cw;
						t = (H - h) / 2
					} else {
						h = Math.min(H, ch);
						w = (cw * h) / ch;
						t = (H - h) / 2
					}

					$(img).css({width: `${w}px`,height: `${h}px`,top: `${t}px`,visibility: ''})
					.fadeIn("slow", function(){$(this).siblings('.loading').remove()})
				})
			},
		},
	},
	methods: {
		parseTitle (v){
			if (v.length == 0) return '未分类';
			return v.replace(/^id_\d+_::/i, '')
		},
		branchOpen (type, index){
			let tmpobj = {};
			tmpobj[index] = (type == 'minus') ? false : true;
			tmpobj = $.extend({}, this.subCategoryClose, tmpobj);
			this.$set(this, 'subCategoryClose', tmpobj)
		},
		dialogClose (){
			this.unSelect();
			EventBus.$emit("show_filemanager", false)
		},
		imgFocus (index, src){/* 设置焦点 */
			if (this.multiselect) {
				let _had_ = this.selectedIdx.findIndex(v => v == index);
				if (_had_ > -1) {
					this.getFiles.splice(_had_, 1);
					this.selectedIdx.splice(_had_, 1)
				} else {
					this.getFiles.push(src);
					this.selectedIdx.push(index)
				}
			} else {
				this.getFiles = [src];
				this.selectedIdx = [index]
			}
		},
		selectAll (){/* 全选 */
			this.unSelect();
			this.items.forEach((c, i) => {
				this.getFiles.push(c.fpath);
				this.selectedIdx.push(i)
			})
		},
		deleteBatch (){/* 批量删除 */
			let vm = this, files = vm.getFiles;
			vm.$Modal.confirm({
				content: '该操作会影响引用此文件的页面显示，确定删除吗？',
				loading: true,
				onOk (){
					let that = this, fnamearr = [];
					// Filter
					if (! $.isArray(files) || !files.length) {
						that.$Notice.warning({
							title: '文件删除失败',
							desc: '非法请求'
						});
						return false
					} else {
						files.forEach(c => fnamearr.push(
							c.substr(c.lastIndexOf("/") + 1)
						))
					}
					
					jGlobal.xhrPost('file/batch_delete', {fnamearr}, res => {
						if (! $.isPlainObject(res)
							|| $.isEmptyObject(res)) return false;
						
						if (res.result == 'OK') {
							vm.unSelect();
							vm.fileSearch()
						} else {
							that.$Notice.warning({
								title: '文件删除失败',
								desc: fnamearr.join() + ' - ' + res.data.errmsg
							})
						}
						that.$Modal.remove()
					}, err => console.error(err))
				}
			})
		},
		fileMoveTo (val){/* 移动至 */
			let filenames = [];
			this.getFiles.forEach(c => filenames.push(
				c.substr(c.lastIndexOf("/") + 1)
			));

			jGlobal.xhrPost('file/change_category', {filenames, catename:val}, res => {
				if (! $.isPlainObject(res)
					|| $.isEmptyObject(res)) return false;
				
				if (res.result == 'OK') {
					this.unSelect();
					this.fileSearch()
				} else if (res.result == 'ERROR') {
					this.$Notice.warning({
						title: '文件移动失败',
						desc: (res.data.errmsg=='-1') ? '分类不存在' : '非法文件名'
					})
				}

				this.$Modal.remove()
			}, err => console.error(err))
		},
		unSelect (){/* 取消选择 */
			this.getFiles = [];
			this.selectedIdx = []
		},
		picSelect (){/* 选择使用 */
			let _files = this.getFiles;
			if (! $.isArray(_files) || ! _files.length) return false;
			EventBus.$emit("select_picture", this.multiselect ? _files : _files[0]);
			this.unSelect()
		},
		addCategory (){/* 资源分类添加 */
			// Filter
			if ($.trim(this.catename).length == 0) {
				this.$Notice.warning({
					title: '分类添加失败',
					desc: this.catename + ' - 请输入分类名称'
				});
				return false
			}

			jGlobal.xhrPost('file/add_category', {catename: this.catename}, res => {
				if (! $.isPlainObject(res)
					|| $.isEmptyObject(res)) return false;
				
				if (res.result == 'OK') {
					this.catename = '';
					// Get 'categories' list
					loadCategoryByXhr({}, res => {
						this.categories = res.catearr || []
					})
				} else {
					this.$Notice.warning({
						title: '分类添加失败',
						desc: this.catename + ' - ' + res.data.errmsg
					})
				}
			}, err => console.error(err))
		},
		addSubCategory (fathercate, e){/* 资源子分类添加 */
			let $input = $(e.target || e.srcElement).closest('.children').children('input');
			let catename = $input.val() || ''
			// Filter
			if ($.trim(catename).length == 0) {
				this.$Notice.warning({
					title: '子分类添加失败',
					desc: catename + ' - 请输入分类名称'
				});
				return false
			}
			
			jGlobal.xhrPost('file/add_category', {fathercate, catename}, res => {
				if (! $.isPlainObject(res)
					|| $.isEmptyObject(res)) return false;
				
				if (res.result == 'OK') {
					$input.val('');
					// Get 'categories' list
					loadCategoryByXhr({}, res => {
						this.category_children = res.childcatearr || {}
					})
				} else {
					this.$Notice.warning({
						title: '分类添加失败',
						desc: catename + ' - ' + res.data.errmsg
					})
				}
			}, err => console.error(err))
		},
		showCateInput (category, e){
			this.renameCtag = category
			// Set input-value
			let $parent = $(e.target).closest(['.father', '.children']);
			if (!$parent.length) return false
			setTimeout(() => {
				$('input', $parent[0].elem).val(this.parseTitle(category))
			}, 0)
		},
		categoryEdit (catename, e){/* 资源分类编辑 */
			let $parent = $(e.target).closest(['.father', '.children']);
			let ncatename = $('input', $parent[0].elem).val();
			// Filter
			let errmsg = ''
			if (! $.trim(ncatename).length) errmsg = '请输入分类名称';
			else {
				let regexp = new RegExp('::' + $.trim(ncatename) + '$');
				if (regexp.test(catename)) {this.renameCtag = -1;return false}
			}

			if (errmsg.length > 0) {
				this.$Notice.warning({
					title: '分类编辑失败',
					desc: catename + ' - ' + errmsg
				});
				return false
			}
			
			// Edit category
			jGlobal.xhrPost('file/rename_category', {catename, ncatename}, res => {
				if (! $.isPlainObject(res)
					|| $.isEmptyObject(res)) return false;
				
				if (res.result == 'OK') {
					// Get 'categories' list
					loadCategoryByXhr({}, res => {
						this.categories = res.catearr || [];
						this.category_children = res.childcatearr || {}
					})
				} else {
					this.$Notice.warning({
						title: '分类重命名失败',
						desc: catename + ' - ' + res.data.errmsg
					})
				}
			}, err => console.error(err))
		},
		categoryDelete (catename){/* 资源分类删除 */
			let vm = this;
			vm.$Modal.confirm({
				content: '该操作会将该分类及其下级分类下所有的文件全部删除，是否继续？',
				loading: true,
				onOk (){
					let that = this;
					// Filter
					if ($.trim(catename).length == 0) {
						that.$Notice.warning({
							title: '分类删除失败',
							desc: catename + ' - 非法请求'
						});
						return false
					}
					
					jGlobal.xhrPost('file/del_category', {catename}, res => {
						if (! $.isPlainObject(res)
							|| $.isEmptyObject(res)) return false;
						
						if (res.result == 'OK') {
							loadCategoryByXhr({}, res => {
								vm.categories = res.catearr || [];
								vm.category_children = res.childcatearr || {}
							})
						} else {
							that.$Notice.warning({
								title: '分类删除失败',
								desc: catename + ' - ' + res.data.errmsg
							})
						}
						that.$Modal.remove()
					}, err => console.error(err))
				}
			})
		},
		categoryTofather (catename, fathername = 'top'){/* 资源上级分类重置 */
			this.showSuperCate = true;
			this.current_cname = catename;
			this.current_fathercname = fathername
		},
		superCategorySet (){
			let tag = this.current_cname,
			parentcate = this.current_fathercname;
			if (parentcate == 'top') parentcate = '';
			
			jGlobal.xhrPost('file/change_parent_category', {tag, parentcate}, res => {
				if (! $.isPlainObject(res)
					|| $.isEmptyObject(res)) return false;
				
				if (res.result == 'OK') {
					loadCategoryByXhr({}, res => {
						this.categories = res.catearr || [];
						this.category_children = res.childcatearr || {}
					})
				} else {
					this.$Notice.warning({
						title: '上级分类设置失败',
						desc: tag + ' - ' + res.data.errmsg
					})
				}
			}, err => console.error(err))
		},
		pageSwitch (page){/* 页码切换 */
			let tag = this.cur_category, type = this.tabtype;
			loadFilesByXhr({type, page, tag}, res => {
				if (res.result == 'ERROR') {
					this.file_err_str = res.data.errmsg;
					return false
				}

				this.curr_page = page;
				this.items = res.data || [];
				if (! this.items || ! this.items.length) this.file_err_str = '尚未上传资源'
			})
		},
		tabSwitch (type){/* 标签切换 */
			this.keyword = '';
			this.cur_category = '';
			this.tabtype = type;
			loadFilesByXhr({type}, res => {
				if (res.result == 'ERROR') {
					this.file_err_str = res.data.errmsg;
					return false
				}

				this.items = res.data || [];
				this.items_total = parseInt(res.total || 0);
				this.curr_page = res.page || 1;
				this.page_size = res.pagesize || 15;
				if (! this.items || ! this.items.length) this.file_err_str = '尚未上传资源'
			});
			// Reset 'upload' configuration
			let extobj = this.filestype[type] || {};
			this.file_accept = extobj.fileext || '';
			this.file_allowext = extobj.allowext || '';
			this.file_maxsize = (extobj.upload_size || 2) * 1024 * 1024
		},
		fileDelete (fname){/* 资源删除 */
			let vm = this;
			vm.$Modal.confirm({
				content: '该操作会影响引用此文件的页面显示，确定删除吗？',
				loading: true,
				onOk (){
					let that = this;
					// Filter
					if ($.trim(fname).length == 0) {
						that.$Notice.warning({
							title: '文件删除失败',
							desc: fname + ' - 非法请求'
						});
						return false
					}
					
					jGlobal.xhrPost('file/delete', {fname}, res => {
						if (! $.isPlainObject(res)
							|| $.isEmptyObject(res)) return false;
						
						if (res.result == 'OK') vm.fileSearch();
						else {
							that.$Notice.warning({
								title: '文件删除失败',
								desc: `${fname} - ${res.data.errmsg}`
							})
						}

						that.$Modal.remove()
					}, err => console.error(err))
				}
			})
		},
		fileRename (index, e){/* 资源重命名 */
			this.renameid = -1;
			let curobj = this.items[index],
			fname = curobj.fname, nfname = curobj.fbasename,
			suffix = fname.replace(/^[^\.]+\./i, '.');
			nfname += suffix;
			// Filter
			let errmsg = '';
			if ($.trim(nfname).length == 0) errmsg = '请输入文件名称';
			else if (fname == $.trim(nfname)) errmsg = '请输入新的文件名称';

			if (errmsg.length > 0) {
				this.$Notice.warning({
					title: '文件重命名失败',
					desc: fname + ' - ' + errmsg
				});
				return false
			}
			
			this.$set(this.items[index], 'fname', nfname);
			jGlobal.xhrPost('file/rename', {fname, nfname}, res => {
				if (! $.isPlainObject(res)
					|| $.isEmptyObject(res)) return false;
				
				if (res.result == 'ERROR') {
					this.$Notice.warning({
						title: '文件重命名失败',
						desc: fname + ' - ' + res.data.errmsg
					})
					this.$set(this.items[index], 'fname', fname);
					this.$set(this.items[index], 'fbasename', fname.replace(suffix, ''))
				}
			}, err => console.error(err))
		},
		fileSearch (){/* 关键词检索 */
			loadFilesByXhr({
				type: this.tabtype,
				keyword: this.keyword,
				tag: this.cur_category
			}, res => {
				if (res.result == 'ERROR') {
					this.file_err_str = res.data.errmsg;
					return false
				}

				this.items = res.data || [];
				this.items_total = parseInt(res.total || 0);
				this.curr_page = res.page || 1;
				this.page_size = res.pagesize || 15;
				if (! this.items || ! this.items.length) this.file_err_str='尚未上传资源'
			})
		},
		categorySearch (tag){/* 分类检索 */
			this.keyword = '';
			this.cur_category = tag;
			loadFilesByXhr({tag, type: this.tabtype}, res => {
				if (res.result == 'ERROR') {
					this.file_err_str = res.data.errmsg;
					return false
				}
				
				this.items = res.data || [];
				this.items_total = parseInt(res.total || 0);
				this.curr_page = res.page || 1;
				this.page_size = res.pagesize || 15;
				if (! this.items || ! this.items.length) this.file_err_str = '尚未上传资源'
			})
		},
		uploadSuccess (res, file){/* 资源上传(2) */
			if (res.result == 'OK') {
				this.$Notice.success({
					title: '文件上传成功',
					desc: file.name + ' 文件上传成功'
				});
				// Update 'file-manager'
				this.categorySearch(this.cur_category)
			} else {
				this.$Notice.warning({
					title: '文件上传失败',
					desc: `${file.name} - ${res.data.errmsg}`
				})
			}
		},
		maxSizeTips (file){/* 资源上传(4) */
			let ftypobj = this.filestype[this.tabtype];
			this.$Notice.warning({
				title: '超出文件大小限制',
				desc: '文件 '+ file.name +' 太大，不能超过 '+ ftypobj.upload_size + 'M'
			})
		},
	},
	props: ['fmtype', 'multiselect', 'con_height', 'con_main_left_height'],
}
</script>

<style type="text/css">.ivu-notice {z-index: 15000;}
.dig-main .ivu-tabs-tab {line-height: 34px;}
.upFile .ivu-upload-select {width: 100%;}
.page-setup .setup-btn .ivu-input {background-color: #eee;width: 90%;left: 5%;}
.ivu-notice {z-index: 10001 !important;}
</style>
<style scoped>
.list-li-top .selectState {display: none;position: absolute;left: 0;right: 0;bottom: 0;top: 0;background-color: rgba(45, 140, 240,.8);border: 2px solid #2d8cf0;text-align: center;line-height: 60px;color: #fff;font-size: 30px;}
.list-li-top.selected .selectState {display: block;}
.confirm_btn {position: absolute;width: 90%;height: 36px;line-height: 36px;background-color: #2d8cf0;color: #fff;text-align: center;bottom: 5px;left: 50%;transform: translate(-50%);border-radius: 4px;cursor: pointer;z-index: 10;}
.ivu-btn-success {color: #fff;background-color: #2d8cf0;border-color: #2d8cf0;}
.searchAndOpera {position: absolute;right: 10px;top: 9px;text-align: right;}
.searchAndOpera .page_opera .opera-list-sele {border-color: #2d8cf0;color: #2d8cf0;}
.searchAndOpera .page_opera .opera-list {display: inline-block;height: 32px;box-sizing: border-box;line-height: 30px;border: 1px solid #2d8cf0;color: #2d8cf0;padding: 0 15px;border-radius: 4px;cursor: pointer;}
.page-setup .upFile .ivu-upload .ivu-btn {border-radius: 0;width: 100%;height: 50px;font-size: 14px;}
.clearFix:after {content: '';clear: both;width: 0;height: 0;display: block;}
.loading {position: absolute;left: 0;top: 0;width: 106px;height: 100%;background: url(../assets/loading.gif) no-repeat center;z-index: 1;}
.mask {width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.5);position: fixed;left: 0;top: 0;z-index: 999;}
.supercate-set {width: 100%;overflow: hidden;}
.supercate-set > li {float: left;width: 100%;}
.supercate-set label.ctitle {display: inline-block;float: left;height: 32px;line-height: 32px;width: 70px;}
.supercate-set .content {float: left;line-height: 32px;}
.inprename {border: 1px solid #e9e9e9;border-radius: 3px;height: 25px;margin-top: 1px;padding: 0 3px;text-align: center;width: 72px;}
span.empty {color: #f00;display: block;height: 30px;line-height: 30px;margin: 0 auto;width: 96%;}
.dig {width: 880px;height: 100%;background-color: #fff;position: fixed;z-index: 999;min-height: 400px;}
.dig_title {width: 100%;height: 64px;line-height: 60px;padding: 0 15px;font-size: 14px;}
.dig_title .fr {cursor: pointer;}
.dig_title .fr:hover {transform: rotate(720deg);}
.dig_title .fr:before {height: 35px;line-height: 35px;}
.dig_operate {margin: 0 auto;}
.dig-main .main-left {box-sizing: border-box;border-right: 1px solid #e9e9e9;height: 100%;}
.dig-main .main-left .main-left-list {padding: 10px;}
.dig-main .main-left .main-left-list .list-li {width: 106px;margin: 0 6px 10px 6px;cursor: pointer;position: relative;}
.dig-main .main-left .main-left-list .list-li:hover .list-li-top {border-color: #2d8cf0;}
.dig-main .main-left .main-left-list .list-li:hover .list-li-delete {display: block;}
.dig-main .main-left .main-left-list .list-li .list-li-top {width: 100%;height: 110px;text-align: center;border: 1px solid #e9e9e9;}
.dig-main .main-left .main-left-list .list-li .list-li-top > img {display: inline;position: relative;border: none;padding: 0;max-width: 100%;}
.dig-main .main-left .main-left-list .list-li .list-li-bottom {height: 27px;line-height: 27px;margin: 0 0 3px;text-align: left;text-overflow: ellipsis;width: 106px;overflow: hidden;}
.dig-main .main-left .main-left-list .list-li .list-li-delete {position: absolute;width: 15px;height: 15px;text-align: center;line-height: 15px;background-color: #2d8cf0;color: #fff;top: 0;right: 0;display: none;}
.dig-main .page-btn {text-align: center;}
.dig-main .main-right {height: 100%;}
.dig-main .main-right .page-setup {position: relative;height: 100%;padding-bottom: 50px;}
.dig-main .main-right .page-setup .father {padding: 8px;cursor: pointer;}
.dig-main .main-right .page-setup .father .fr {display: none;}
.dig-main .main-right .page-setup .father .fr .page-setup-li {font-size: 16px;padding: 3px;}
.dig-main .main-right .page-setup .father .page-setup-father {font-size: 10px;padding: 3px;}
.dig-main .main-right .page-setup .father span {margin-left: 6px;line-height: 20px;}
.dig-main .main-right .page-setup .father.active {color: #2d8cf0;}
.dig-main .main-right .page-setup .father:hover {color: #2d8cf0;}                        
.dig-main .main-right .page-setup .father:hover .fr {display: block;} 
.dig-main .main-right .page-setup .children {padding: 8px;cursor: pointer;background-color: #fff;}
.dig-main .main-right .page-setup .children .fr {display: none;}
.dig-main .main-right .page-setup .children .fr .page-setup-li {font-size: 16px;padding: 3px;}
.dig-main .main-right .page-setup .children span {margin-left: 25px;line-height: 20px;}
.dig-main .main-right .page-setup .children.active {color: #2d8cf0;}
.dig-main .main-right .page-setup .children:hover {color: #2d8cf0;}
.dig-main .main-right .page-setup .children:hover .fr {display: block;}
.dig-main .main-right .page-setup .setup-btn {position: absolute;top: auto;bottom: 18px;margin-left: 0;}
.dig_title {border-bottom: 1px solid #dddee1;border-top: 4px solid #2d8cf0;background-color: #fafafa;font-size: 14px;color: #2d8cf0;}
.dig_title .fr {padding: 5px;margin-top: 17px;color: #bfbfbf;cursor: pointer;}
.dig-main {position: absolute;left: 0;right: 0px;top: 64px;bottom: 0;}
.dig-main .main-left {position: absolute;left: 0;right: 211px;top: 0;bottom: 0;padding-left: 20px;}
.dig-main .main-right {width: 210px;}
.page-setup .categoryBox {position: absolute;left: 0;top: 50px;right: 0;bottom: 55px;padding: 16px 0 0;}
.dig-main .main-right .categoryBox .category-main .father {border-bottom: 1px solid  #dddee1;}
.dig-main .main-right .categoryBox .category-main .father .catrename {width: 53%;border-radius: 4px;height: 32px;padding: 0 5px;border: 1px solid #dddee1;}
.dig-main .main-right .categoryBox .category-main .children {border-bottom: 1px solid #dddee1;}
.dig-main .main-right .categoryBox .category-main .children .catrename {width: 60%;border-radius: 4px;height: 32px;padding: 0 5px;border: 1px solid #dddee1;}
.dig-main .main-right .categoryBox .category-main .children .children_ipt {width: 60%;border-radius: 4px;height: 32px;padding: 0 5px;border: 1px solid #dddee1;}
.tanchuang-content {height: 100%;position: relative;}
.tanchuang-content .tanchuang-content-box {position: absolute;left: 0;right: 0;top: 0;bottom: 55px;width: 100%;height: 100%;}
@keyframes file-fadein {
	0% {opacity: 0;}
	100% {opacity: 1;}
}
@keyframes file-zoom {
	0% {transform: scale(0);}
	50% {transform: scale(1.1);}
	100% {transform: scale(1);}
}
.mask.file-fade-enter-active {animation: file-fadein 0.5s;}
.dig {animation: file-zoom 0.5s;}
</style>


// WEBPACK FOOTER //
// file-manager.vue?93529fe8